// const PUB_REQUEST_BASE = "" // 访问服务器环境服务

// const PUB_REQUEST_BASE = "http://jiaohuanji.yunyakeji.cn" // 公司测试服

const PUB_REQUEST_BASE = "http://app.scop-cloud.com" // 客户正式域名
const DEVICE_REQUEST_BASE = "http://app.scop-cloud.com:7192" // 客户正式域名

// const PUB_REQUEST_BASE = "http://183.11.229.83:8889" // 客户公网IP

// const PUB_REQUEST_BASE = "http://192.168.5.249" // 客户正式内网域名
// const DEVICE_REQUEST_BASE = "http://192.168.5.249:7192" // 客户正式内网域名

// ———————————————————————————————————————————————————————————————————————————————————

import { useUserStore } from "@/store/user"
import { Info } from "@/types/global"
import axios from "axios"
import { useRouter } from "vue-router"
const router = useRouter()
let user: any = null;

const pubRequest = axios.create({
    baseURL: PUB_REQUEST_BASE,
    timeout: 30000,
})

pubRequest.interceptors.request.use((config: any) => {
    const tk = localStorage.getItem('user-token')
    if (tk) config.headers['user-token'] = tk
    config.headers['lang'] = localStorage.getItem('lang') != "en" ? "zh" : "en";
    config.url = `/api/m6132/${config.url}`
    return config;
}, function (err) {
    return Promise.reject((err || {}).data)
})

pubRequest.interceptors.response.use(function (res) {
    if (res.data.code == 1) return res.data;
    else if (res.data.code == '-201' || res.data.code == '-202' || res.data.code == '-203' || res.data.code == 'U0230') {
        if (!user) user = useUserStore();
        user.loginOut();
        // router.replace('/');
        location.href = location.origin;
    }
    return Promise.reject(res.data);
}, function (err) {
    return Promise.reject((err || {}).data)
})

import { Response } from '@/types/global';
export const post = function (url: string, data: Info): Promise<Response> { return pubRequest.post(url, data) }

const deviceRequest = axios.create({
    baseURL: DEVICE_REQUEST_BASE,
    timeout: 10000,
    headers: {
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
})

/**
 * 设备请求函数，用于向设备发送远程控制请求
 * @param {Info} data - 包含设备控制信息的参数对象
 * @returns {Promise} - 返回一个Promise对象，用于处理异步操作结果
 */
export const deviceReq = (data: Info) => {
    return new Promise((resolve, reject) => {
        deviceRequest.post('/api/device/remoteCtrlDevice', data).then(res => {
            if (res.data.code == 0) {
                resolve(res.data)
            } else {
                reject(res.data)
            }
        }).catch(err => { reject(err) })
    })
}